import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { loadScriptsInHeadSequentially } from '../../utils/dom';

export class HtmlCard extends Component {
  componentDidMount() {
    this.scrollScripts = [];
    this.onMountOrUpdate();
  }

  /*
   * When one HTML card turns into another,
   * the HTML Card component stays mounted and
   * triggers neither mount nor unmount hooks. We should account
   * for that case here.
   */
  componentDidUpdate() {
    // In case the event listener was removed, attach it back.
    this.onMountOrUpdate();
  }

  /*
   * Every time the section changes, we need to make sure
   * that any new scripts will be loaded on scroll.
   */
  onMountOrUpdate() {
    this.scrollScripts = this.getScripts();
    loadScriptsInHeadSequentially(this.scrollScripts);
  }

  getScripts() {
    const dummy = document.createElement('div');

    dummy.innerHTML = this.props.content.resource;
    /*
     * For HTML Card, this.props.content.resource is where
     * <script> tags are located.
     *
     * In case we generalize this component and make it usable
     * by things other than HTML Card, we can make the path
     * to the scripts a configurable option of this HOC.
     *
     * `git blame` this comment to see a prior version of this
     * HOC where that was the case.
     */
    const scripts = dummy.getElementsByTagName('script');
    return scripts ? Array.from(scripts) : [];
  }

  render() {
    const { content, cardID } = this.props;
    /*
     * Since 'withScriptTagExecution' loads all <script> tags for us, we don't
     * need to insert them in the section markup...
     */

    const resourceWithoutScripts = () => {
      /*
       * This is jQuery's regex for removing <script> tags.
       * Source: https://stackoverflow.com/a/6660315
       */
      const scriptTagRemovalRegex =
        /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      return content.resource.replace(scriptTagRemovalRegex, '');
    };

    return (
      <div className="section-html">
        <div id={cardID} dangerouslySetInnerHTML={{ __html: resourceWithoutScripts() }} />
      </div>
    );
  }
}

HtmlCard.propTypes = {
  content: PropTypes.shape({
    resource: PropTypes.string.isRequired
  }).isRequired,
  cardID: PropTypes.number.isRequired
};

export default HtmlCard;
